import api from './api';

export interface UserActivityRow {
  id: number;
  user_id: number | null;
  user_name: string;
  kind: 'action' | 'page';
  action: string;
  description: string;
  path: string | null;
  is_impersonated: boolean;
  actor_name: string | null;
  occurred_at: string;
  date_time: string;
}

export interface UserActivityResponse {
  user: { id: number; name: string } | null;
  summary: { actions_today: number; actions_week: number; actions_month: number; period_actions: number; period_pages: number; active_days: number; active_users: number; last_activity: string | null };
  daily: { date: string; label: string; actions: number; pages: number }[];
  users: { user_id: number; name: string; actions: number; pages: number }[];
  data: UserActivityRow[];
  total: number;
  page: number;
  last_page: number;
}

export const userActivityService = {
  async list(params: { user_id?: number; days: number; kind?: string; page: number; search?: string }): Promise<UserActivityResponse> {
    const { data } = await api.get<UserActivityResponse>('/user-activity', { params });
    return data;
  },
  async trackPage(path: string): Promise<void> {
    await api.post('/user-activity/page', { path });
  },
};
